import React from 'react';
import { Box, Typography } from '@material-ui/core';
import IntlMessages from 'util/IntlMessages';

const DidYouMean = (props) => (
  <Box
    display="flex"
    alignItems="center"
    gap={1}
    py={1}
    px={1.5}
    bgcolor="#fff8e1"
    borderRadius={1}
    border="1px solid #ffd54f"
    {...props}
  >
    <Typography variant="caption" color="textSecondary" style={{ opacity: 0 }}>
      <IntlMessages id="ui.searchExperienceV2.core.blocks.didYouMean.didYouMean" />
    </Typography>
    <Box px={1.5} py={0.25} bgcolor="#ffeb3b" borderRadius={1}>
      <Typography variant="caption" style={{ opacity: 0, fontWeight: 600 }}>
        <IntlMessages id="ui.searchExperienceV2.core.blocks.didYouMean.suggestedTerm" />
      </Typography>
    </Box>
  </Box>
);

export default DidYouMean;
